import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const FilterOverlay = function() {
    const changedEventKey = 'filterOverlayChanged';

    const isLoading = useSelector(
        state => state.facetedSearch.isLoading,
        (prevIsLoading, nextIsLoading) => prevIsLoading === nextIsLoading // Custom equality function
    );

    const loaderElRef = useRef(null);

    const handleVisibilityChange = (e) => {
        let productListEl = document.querySelector('.product-list');
        if(!productListEl) return;

        if (e.detail.visible) {
            loaderElRef.current = document.createElement('div');
            loaderElRef.current.classList.add('faceted-search__overlay');
            productListEl.prepend(loaderElRef.current);
        } else {
            if (productListEl.contains(loaderElRef.current)) {
                loaderElRef.current.remove();
            }

            loaderElRef.current = null;
        }
    }

    useEffect(() => {
        document.addEventListener(changedEventKey, handleVisibilityChange);
        return () => document.removeEventListener(changedEventKey, handleVisibilityChange);
    }, []);

    useEffect(() => {
        document.dispatchEvent(new CustomEvent(changedEventKey, { detail: { visible: isLoading } }));
    }, [isLoading]);

    if (!isLoading) return null;

    return <div className="faceted-search__overlay"></div>
}

export default FilterOverlay;
